import React, { Component } from "react";
import Slide from "react-reveal/Slide";
import { Helmet } from "react-helmet";
import Plx from "react-plx";
import { trackPage } from "../utils/tracking";

// components
import PageHero from "../components/page-hero/index";
import PageContent from "../components/page-content";

// actions
import { getPageBySlug } from "../actions";
import EventList from "../components/event-list/index";

class InteriorPage extends Component {
  state = {
    data: {},
    slug: null,
    id: null,
    loading: true
  };

  componentWillMount() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    const { pathname } = this.props.location;
    getPageBySlug(pathname).then(res =>
      this.setState({
        data: res.data,
        slug: res.slug,
        id: res.id,
        loading: false
      })
    );

    trackPage();
  }

  renderMarkup = data => {
    return { __html: data };
  };

  render() {
    const { data, loading } = this.state;

    const gifConfig = [
      {
        start: "self",
        end: `50%`,
        properties: [
          {
            startValue: 200,
            endValue: 0,
            property: `translateY`
          }
        ]
      }
    ];

    const imgConfig = [
      {
        start: "self",
        end: `60%`,
        properties: [
          {
            startValue: 300,
            endValue: 0,
            property: `translateY`
          }
        ]
      }
    ];

    return (
      <main id="interior" className="textured">
        <Helmet>
          <title>{`${data.content_title} | Baileson`}</title>
          <meta name="description" content="Man's other best friend" />
        </Helmet>

        <PageHero loading={loading} image={data.header_image}>
          <Slide bottom cascade>
            <h1
              className="heading heading--medium white"
              dangerouslySetInnerHTML={this.renderMarkup(data.header_content)}
            />
          </Slide>
        </PageHero>
        <div className="interior-content">
          <PageContent
            loading={loading}
            title={data.content_title}
            content={data.content}
            button={{
              show: data.content_has_cta,
              link: data.content_cta_link,
              text: data.content_cta_text
            }}
          />
          {data.content_gif &&
            data.content_image && (
              <div className="interior-content__media">
                <Plx parallaxData={gifConfig}>
                  <div className="animation">
                    <video playsInline autoPlay loop muted height={444}>
                      <source src={data.content_gif} type="video/mp4" />
                    </video>
                  </div>
                </Plx>
                <Plx parallaxData={imgConfig}>
                  <div className="image">
                    <img
                      src={data.content_image}
                      width="925"
                      height="568"
                      alt="about beer"
                    />
                  </div>
                </Plx>
              </div>
            )}
        </div>

        {/* render if page is /about */
        this.props.location.pathname === "/about" && (
          <div className="our-name">
            <h3 className="our-name__title">Our Name</h3>
            <div className="our-name__content">
              <p>
                The name "Baileson" is a concatenation of our dogs' names -
                Bailey and Jameson ("Jamie"). Way back in 2005, Sarah convinced
                Adam that they needed 3 dogs in their lives and Adam agreed,
                with the condition that the dogs be named after a favorite
                college beverage: The Irish Car Bomb (consisting of Bailey's
                Irish Cream, Jameson Whiskey, and a Guinness Stout). So, Bailey
                and Jamie (both puggles) came along and Adam was able to
                convince Sarah that those two dogs were plenty enough. Fast
                forward 10 years and we couldn't think of a better theme to
                brand our pub around than our awesome fur-babies. Fast forward
                another 3 years from then and we finally added the third pup,
                Beau, so we regularly get asked how long before we rename the
                pub "Beauleson". Good question, we're still thinking about that.
              </p>

              {/* <div className="animation">
									<video playsInline autoPlay loop muted height={444}>
										<source
											src="http://api.baileson.c50dev.com/content/uploads/2018/04/pub-crawl.mp4"
											type="video/mp4"
										/>
									</video>
								</div> */}
            </div>
          </div>
        )}

        {/* render if page is /taproom */
        this.props.location.pathname === "/taproom" && <EventList />}
      </main>
    );
  }
}

export default InteriorPage;



// WEBPACK FOOTER //
// ./src/containers/InteriorPage.js